import styled from '@emotion/styled';
import { GUTTER_WIDTH, CONTAINER_MARGINS, CONTAINER_WIDTH } from './config';


interface ContainerProps {
  fluid?: {
    1?: true,
    2?: true,
    3?: false,
    4?: false,
    5?: false,
  };
}

const getHalfOfGutterPixels = (gutter: typeof GUTTER_WIDTH): string => `${gutter / 2}px`;

export const Container = styled.div<ContainerProps>`
  padding-left: ${getHalfOfGutterPixels(GUTTER_WIDTH)};
  padding-right: ${getHalfOfGutterPixels(GUTTER_WIDTH)};

  ${({ theme, fluid = {} }) => theme.media.showAt({ at: 1 })`
    margin-left: ${CONTAINER_MARGINS['1']};
    margin-right: ${CONTAINER_MARGINS['1']};
    width: ${(fluid['1']) ? 'auto' : CONTAINER_WIDTH['1']};
  `}
  ${({ theme, fluid = {} }) => theme.media.showAt({ at: 2 })`
    margin-left: ${CONTAINER_MARGINS['2']};
    margin-right: ${CONTAINER_MARGINS['2']};
    width: ${(fluid['2']) ? 'auto' : CONTAINER_WIDTH['2']};
  `}
  ${({ theme, fluid = {} }) => theme.media.showAt({ at: 3 })`
    margin-left: ${CONTAINER_MARGINS['3']};
    margin-right: ${CONTAINER_MARGINS['3']};
    width: ${(fluid['3']) ? 'auto' : CONTAINER_WIDTH['3']};
  `}
  ${({ theme, fluid = {} }) => theme.media.showAt({ at: 4 })`
    margin-left: ${CONTAINER_MARGINS['4']};
    margin-right: ${CONTAINER_MARGINS['4']};
    width: ${(fluid['4']) ? 'auto' : CONTAINER_WIDTH['4']};
  `}
  ${({ theme, fluid = {} }) => theme.media.showAt({ at: 5 })`
    margin-left: ${CONTAINER_MARGINS['5']};
    margin-right: ${CONTAINER_MARGINS['5']};
    width: ${(fluid['5']) ? 'auto' : CONTAINER_WIDTH['5']};
  `}
`;

